import { CURR_ENV } from '@/core/constants/appConfig/environment';
import { EScriptEnv } from '@/core/constants/appConfig/types';
import { EBundleName } from '@/sources';

import { initSourceEntryPoint } from '../init_entrypoint';
import { ShopifyCustomPixelSourceBundle } from './bundle';

// Initialize the Logger and Data Layer
(() => {
  const wtagFunctionKey: string = initSourceEntryPoint(
    EBundleName.SHOPIFY_CUSTOM_PIXEL,
  );

  try {
    const localStorageKey =
      CURR_ENV === EScriptEnv.PROD
        ? 'wgs_cpx_loaded_prod'
        : `wgs_cpx_loaded_${CURR_ENV}`;
    localStorage.setItem(localStorageKey, 'true');
  } catch {
    // Do nothing
  }

  // Set the script URL
  (window as any)[`wgs_${CURR_ENV}_script`] =
    document.currentScript?.getAttribute('src');
  // Initialize the custom pixel source bundle
  const customPixelSourceBundle: ShopifyCustomPixelSourceBundle =
    new ShopifyCustomPixelSourceBundle({}, (window as any)[wtagFunctionKey]);
  customPixelSourceBundle.init();
})();
